// Module
var code = "<div class=\"dtp-ui-grid\" cg-busy=\"$ctrl.serverOperation\"> <div id=\"skuGrid\" ag-grid=\"$ctrl.marketSkusGridOptions\" class=\"ag-theme-balham\" style=\"min-height:200px\"></div> </div>";
// Exports
module.exports = code;